export const fmtUsd = (n: number) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(n);

export const fmtUsdPrecise = (n: number) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 2,
  }).format(n);

export const fmtPct = (n: number) => `${n.toFixed(1)}%`;

export const fmtPctOf = (part: number, whole: number) =>
  whole > 0 ? fmtPct((part / whole) * 100) : '0.0%';
